import { useLocation } from '@k2/core/location'
import { isSSR } from '@k2/core/util'
import { useOAuth } from 'vue-oidc'
import type { NavigationGuardWithThis } from 'vue-router'

export const logoutGuard: NavigationGuardWithThis<undefined> = async () => {
  if (isSSR) return true

  const { logout } = useOAuth()
  await logout(`${process.env.APP_DOMAIN || useLocation()?.origin}/`)
  return false
}
